export default {
    title:'隐私政策',
    p:[
        '隐私政策',
        // '更新日期：2019年 10月29日',
        // '生效日期：2019 年 10月 29日',
        '本隐私政策将帮助你了解：',
        '（1）为了保障产品的正常运行，实现个性化推荐、发布信息、互动交流、搜索查询等核心功能以及其他功能，我们会收集你的部分必要信息；',
        '（2）在你进行注册认证、发布信息、互动交流或使用基于地理位置的服务时，基于法律要求或实现功能所必须，我们可能会收集姓名、联络方式、通讯录、音视频文件、地理位置等个人敏感信息。你有权拒绝向我们提供这些信息，或者撤回你对这些信息的授权同意。请你了解，拒绝或撤回授权同意，将导致你无法使用相关的特定功能，但不影响你使用的其他功能；',
        '（3）我们会将在境内运营过程中收集和产生的你的个人信息存储于中华人民共和国境内，并不会将上述信息传输至境外。我们仅会在为提供及服务之目的所必需的期间内保留你的个人信息；',
        '（4）我们不会向第三方共享、提供、转让或者从第三方获取你的个人信息，除非经过你的同意；',
        '（5）我们将努力采取合理的安全措施来保护你的个人信息。特别的，我们将采用行业内通行的方式及尽最大的商业努力来保护你个人敏感信息的安全；',
        '（6）会基于算法等人工智能决策机制，推送你可能感兴趣的信息；',
        '（7）你访问、更正、删除个人信息与撤回同意授权的方式，以及注销账号、投诉举报的方式。',
        '如你未明示同意本隐私政策并开始使用，我们将仅收集浏览推荐所必需的信息，这将导致我们无法为你提供完整的产品和服务，但我们同样会采用去标识化、加密等措施来保护这些信息。如果你不同意本隐私政策，我们无法为你提供完整的产品和服务，你也可以选择停止使用。当你选择继续或再次使用时，基于提供产品和服务所必需，将视为你接受和认可我们按照本政策对你的相关信息进行处理。',
        '  （以下简称“我们”）深知个人信息对你的重要性，我们将按照法律法规的规定，采用安全的保护措施，保护你的个人信息及隐私安全。因此，我们制定本“隐私政策”并特别提示：希望你在使用及相关服务前仔细阅读并理解本隐私政策，你可以按照指引作出你的适当选择。',
        '我们希望通过本隐私政策向你说明在你在使用软件及相关服务时，我们将按照本隐私政策收集、使用、存储、共享、转让及保护你的个人信息，向你介绍我们对你个人信息的处理，以及我们为你提供的查询、访问、删除、更正、撤回授权同意和保护这些信息的方式。其中，有关你个人信息权益的条款等重要内容我们已用加粗形式提示，请特别关注。',
        '本隐私政策将帮助你了解以下内容：',
        '一、我们如何收集和使用个人信息',
        '二、我们对 Cookie 和同类技术的使用',
        '三、我们如何存储个人信息',
        '四、我们如何共享、转让、公开披露个人信息',
        '五、我们如何保护个人信息的安全',
        '六、你的权利',
        '七、未成年人使用条款',
        '八、隐私政策的修订和通知',
        '九、适用范围',
        '   其他',
        '一、我们如何收集和使用个人信息',
        '在你使用 及服务的过程中，我们将根据合法、正当、必要的原则，收集信息。我们收集或请你提供的信息将用于：',
        '1.保障产品的正常基础运行；',
        '2.实现各项功能和服务；',
        '3.优化、改善产品和服务；',
        '4.保障产品、服务以及用户使用安全；',
        '5.遵循法律法规与国家标准的规定。',
        '（一）我们主动收集与使用的个人信息',
        '我们会按照如下方式收集你在使用服务时主动提供的，以及你在使用功能或接受服务过程中产生的信息：',
        '1.保障 和相关服务的正常运行',
        '当你使用 及相关服务时，为了保障软件与服务的正常运行，我们会收集你的硬件型号、操作系统版本号、国际移动设备识别码（IMEI）、网络设备硬件地址（MAC）、IP 地址、软件版本号、网络接入方式及类型、操作日志等信息。请你了解，这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息。',
        '2.注册、认证、登录 和相关服务',
        '当你注册、登录 及相关服务时，你可以通过手机号创建账号，我们将通过发送短信验证码来验证你的身份是否有效，并且你可完善相关的网络身份识别信息（如头像、昵称和密码），收集这些信息是为了帮助你完成注册。你还可根据自身需求选择填写性别、生日、地区及介绍等信息完善你的个人信息。另外，将使用蓝牙高精度定位设备及技术，结合  平台，为您提供信息互动等服务。我们将非常重视用户隐私保护及确保信息安全。您进行客商登记参会或使用  平台服务，即表示您同意我们收集和使用您的位置等相关信息，为您提供服务。',
        '（2）在你使用“认证”等需进行身份认证的功能或服务时，根据中华人民共和国相关法律法规，你可能需要提供你的真实身份信息（真实姓名、身份证号码、电话号码等）以完成实名验证。这些信息属于个人敏感信息，我们将采用行业内通行的方式，尽最大的商业努力来保护你个人敏感信息的安全。如果你不提供这些信息，你将可能无法获得相关服务，但不影响 其他功能与服务的正常使用。',
        '3.为你推荐个性化的信息或服务',
        '个性化推荐是 最基础、最核心的功能之一。 为实现这一功能，我们可能会收集并使用下列信息：',
        '（1）关注、收藏、搜索、浏览偏好等你的操作、使用行为信息；',
        '（2）反馈、发布、点赞、评论等你主动提供的信息；',
        '请你了解，我们收集、使用的上述信息进行了去标识化处理，数据分析仅对应特定的、无法直接关联用户身份的编码，无法也绝不会与你的真实身份相关联。',
        '4.为你提供信息发布功能或服务',
        '你发布内容、评论、提问或回答时，我们将收集你发布的信息，并展示你的昵称、头像、发布内容等。',
        '（1）你使用上传图片、发布音视频功能时，我们会请求你授权相机、照片、麦克风等敏感权限。你如果拒绝授权提供，将无法使用此功能，但不影响你正常使用 的其他功能。',
        '（2）你发布信息并选择显示位置时，我们会请求你授权地理位置这一敏感权限，并收集与本服务相关的位置信息。这些技术包括 IP 地址、GPS 以及能够提供相关信息的 WI-FI 接入点、蓝牙和基站等传感器技术。你如果拒绝授权提供，将无法使用此功能，但不影响你正常使用 的其他功能。',
        '5.为你提供互动功能或服务',
        '你主动关注你感兴趣的账号、话题并与之进行互动，进行评论或分享内容时，我们会收集你关注的账号，并向你展示你关注账号发布内容。',
        '6.为你提供搜索服务',
        '你使用 的搜索服务时，我们会收集你的搜索关键字信息、日志记录等。为了提供高效的搜索服务，部分前述信息会暂时存储在你的本地存储设备之中，并可向你展示搜索结果内容、搜索历史记录。',
        '7.开展营销活动',
        '当你选择参加我们举办的有关营销活动时，根据活动需要你可提供姓名、通信地址、联系方式、银行账号等信息。这些信息可能包括个人敏感信息（如个人电话号码、银行账号等），是你收到转账或者礼品所必要的，如果你拒绝提供这些信息，我们将可能无法向你转账或发放礼品。',
        '8.保障产品、服务及用户使用安全',
        '为帮助我们更好地了解 及相关服务的运行情况，以便确保运行与提供服务的安全，我们可能记录网络日志信息，以及使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据等信息。',
        '（一）我们可能从第三方获得的你的个人信息        ',
        '用户因使用我们的产品或者服务而被我们收集的信息，例如其他用户发布的信息中可能含有你的部分信息（如：在评论、留言、发布图文、音视频中涉及到与你相关的信息）。',
        '（二）收集、使用个人信息目的变更的处理        ',
        '请你了解，随着我们业务的发展，可能会对 的功能和提供的服务有所调整变化。原则上，当新功能或服务与个性化推荐、发布信息、互动交流、搜索查询、注册认证等场景相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用你的个人信息，会再次进行告知，并征得你的同意。',
        '（三）依法豁免征得同意收集和使用的个人信息',
        '请你理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用你的个人信息无需征得你的授权同意：',
        '（1）与国家安全、国防安全直接相关的；',
        '（2）与公共安全、公共卫生、重大公共利益直接相关的；',
        '（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；',
        '（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
        '（5）所收集的你的个人信息是你自行向社会公众公开的；',
        '（6）从合法公开披露的信息中收集的你的个人信息的，如合法的新闻报道、政府信息公开等渠道；',
        '（7）根据你的要求签订或履行合同所必需的；',
        '（8）用于维护 软件及相关服务的安全稳定运行所必需的，例如发现、处置 软件及相关服务的故障；',
        '（9）为合法的新闻报道所必需的；',
        '（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；',
        '（11）法律法规规定的其他情形。',
        '特别提示你注意，如信息无法单独或结合其他信息识别到你的个人身份，其不属于法律意义上你的个人信息；当你的信息可以单独或结合其他信息识别到你的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他你的个人信息结合使用时，这些信息在结合使用期间，将作为你的个人信息按照本隐私政策处理与保护。',
        '二、对 Cookie 和同类技术的使用',
        'Cookie 和同类技术是互联网中的通用常用技术。当你使用 及相关服务时，我们可能会使用相关技术向你的设备发送一个或多个 Cookie 或匿名标识符，以收集和存储你访问、使用本产品时的信息。我们使用 Cookie 和同类技术主要为了实现以下功能或服务：',
        '（一）保障产品与服务的安全、高效运转',
        '我们可能会设置认证与保障安全性的 cookie 或匿名标识符，使我们确认你是否安全登录服务，或者是否遇到盗用、欺诈等不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。',
        '（二）帮助你获得更轻松的访问体验',
        '使用此类技术可以帮助你省去重复你填写个人信息、输入搜索内容的步骤和流程（例如：记录搜索历史）。',
        '（三）为你推荐、展示、推送你可能感兴趣的内容或账号',
        '我们可能会利用 Cookie 和同类技术（例如 Beacon、Proxy 等技术）了解你的偏好和使用习惯，进行咨询或数据分析，以改善产品服务及用户体验，并优化你对广告的选择。 我们承诺，我们不会将 Cookie 用于本隐私政策所述目的之外的任何其他用途。',
        '三、我们如何存储个人信息',
        '（一）信息存储的地点',
        '我们依照法律法规的规定，将在境内运营过程中收集和产生的你的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循法律法规的规定，征求你的自主选择同意。',
        '（二）存储期限',
        '我们仅在为提供 及服务之目的所必需的期间内保留你的个人信息，例如，你发布的信息、评论、点赞等信息，在你未撤回、删除或未注销账号期间，我们会保留相关信息。超出必要期限后，我们将对你的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。',
        '四、我们如何共享、转让、公开披露个人信息',
        '（一）个人信息的共享、转让',
        '我们不会向第三方共享、转让你的个人信息，除非经过你本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。',
        '1.在下列情况下，经过你的自主选择同意，我们可能会共享的个人信息',
        '（1）帮助你使用 账号登录第三方产品',
        '当你使用 登录第三方产品时，经过你的明示同意，我们会将你的昵称、头像等信息与你登录的第三方产品共享。',
        '（2）为实现程序化广告推送，我们可能会与广告合作伙伴共享去标识化或匿名化处理后的信息        ',
        '我们可能与委托我们进行推广和广告投放的合作伙伴共享信息，但我们不会分享用于识别你个人身份的信息，例如你的姓名、身份证号等，仅会向这些合作伙伴提供难以识别你个人身份的用户画像标签及去标识化或匿名化后的信息，以帮助其在不识别你个人身份的前提下提升广告有效触达率。你可以拒绝我们向你推送程序化广告，但不影响你使用其他服务。',
        '（3）为实现特定功能而与业务合作伙伴共享',
        '当软件服务提供商、智能设备提供商或系统服务提供商与我们联合为你提供服务时，例如你需要使用地理位置功能时，为实现这一功能，我们可能会收集你的位置信息及相关设备信息（例如硬件型号、操作系统版本号、国际移动设备身份识别码（IMEI）、网络设备硬件地址（MAC））经过去标识化后并提供给前述提供商。',
        '（4）帮助你参加营销推广活动',
        '当你选择参加我们举办的有关营销活动时，根据活动需要你提供姓名、通信地址、联系方式、银行账号等信息。经过你的明示同意，我们会将上述信息与第三方共享以便我们能委托第三方及时向你提供奖品。',
        '2.对共享个人信息第三方主体的谨慎评估及责任约束',
        '（1）经你同意，我们只会与第三方共享实现目的所必要的信息。如果第三方因业务需要，确需超出前述授权范围使用个人信息的，该第三方将需再次征求你的自主选择同意。',
        '（2）对我们与之共享你个人信息的第三方，该些第三方会与我们签订保密协议。同时，我们会对其数据安全能力与环境进行评估，并要求第三方以不低于本隐私政策所要求的保密和安全措施来处理该些信息。',
        '3.收购、兼并、重组时个人信息的转让',
        '随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，你的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所要求的安全标准继续保护或要求个人信息的继受方继续保护你的个人信息，否则我们将要求继受方重新征得你的授权同意。',
        '（二）个人信息的公开披露        ',
        '我们不会公开披露你的信息，除非遵循国家法律法规规定或者获得你的自主选择同意。我们公开披露你的个人信息会采用符合行业内标准的安全保护措施，具体如下：',
        '1. 对违规账号、欺诈行为进行处罚公告时，我们会披露相关账号的必要信息。',
        '2.“寻人”、“追逃”等公益项目，经根据符合法律法规的明确授权后，我们会公开披露与事件相关的信息。当事件结束后，我们将及时删除已披露的个人敏感信息。',
        '（三）依法豁免征得同意共享、转让、公开披露的个人信息',
        '请你理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露你的个人信息无需征得你的授权同意：',
        '（1）与国家安全、国防安全直接相关的；',
        '（2）与公共安全、公共卫生、重大公共利益直接相关的；',
        '（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；',
        '（4）出于维护你或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
        '（5）你自行向社会公众公开的个人信息；',
        '（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。',
        '五、我们如何保护个人信息安全',
        '（一）我们非常重视你个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护你的个人信息，防止你提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。',
        '（二）我们会使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护你的个人信息，并使用安全保护机制防止你的个人信息遭到恶意攻击。',
        '（三）我们会建立专门的安全部门、安全管理制度、数据安全流程保障你的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问你的个人 信息，并适时对数据和技术进行安全审计。',
        '（四）尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请你理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保你提供给我们的个人信息的安全性。你知悉并理解，你接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议你采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。        ',
        '（五）我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止该等安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向你告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、你可自主防范和降低风险的建议、对你的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函、短信等形式告知你，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。        ',
        '（六）我们谨此特别提醒你，本隐私政策提供的个人信息保护措施仅适用于 及相关服务。一旦你离开 及相关服务，浏览或使用其他网站、服务及内容资源，我们即没有能力及义务保护你在 及相关服务之外的软件、网站提交的任何个人信息，无论你登录、浏览或使用上述软件、网站是否基于 的链接或引导。',
        '六、你的权利',
        '我们非常重视你对个人信息的管理，并尽全力保护你对于你个人信息的访问、修改（更新或更正）、删除以及撤回授权同意的权利，以使你拥有充分的能力保障你的隐私和安全。',
        '（一）访问、删除、更正你的个人信息',
        '你可以通过以下方式管理你的信息：',
        '你可以查询、访问、更正你的头像、用户名、简介、性别、生日、地区、位置、邮箱等基本信息（手机号信息除外），你可以在  的“设置”中进行查询、访问、更正。',
        '（二）自主选择控制个性化推荐信息',
        '我们的相关信息推荐等功能可能会根据信息系统、算法等在内的非人工自动决策机制作出，当你对我们推送的信息不感兴趣或希望减少某些信息推荐时，你可以从设置-我的商贸需求中更改你的标签设置。这会有助你对推送信息的控制与自主决策。',
        '你也可以通过登录 客户端中的“反馈意见”页面入口与我们联系，你的反馈我们将会及时处理回复。',
        '（三）改变你授权同意范围或撤销授权',
        ' 当你对我们推送的信息不感兴趣或希望减少某些信息推荐时，你可以在我的-设置-我的商贸需求中更改你的标签信息。',
        '（四）投诉举报',
        '你可按照我们公示的制度进行投诉或举报。如果你认为你的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索（例如：认为我们收集你的个人信息违反法律规定或者双方约定），你可以通过点击“设置”-反馈意见，进入用户反馈界面与我们联系。我们核查后会及时反馈你的投诉与举报。',
        '（五）访问隐私政策',
        '你可以在注册页面，或者在登录个人账号“设置”—“隐私政策”查看本隐私政策的全部内容。',
        '（六）停止运营向你告知',
        '如我们停止运营，我们将及时停止收集你个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知你，并对所持有的你的个人信息进行删除或匿名化处理。',
        '七、未成年人条款',
        '若你是未满 18 周岁的未成年人，在使用 及相关服务前，应在你的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。 我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、储存、共享、转让或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。 若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过公司本隐私政策公示的联系方式与我们联系。',
        '八、隐私政策的修订和通知 ',
        '（一）为给你提供更好的服务， 及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分。',
        '（二）本隐私政策更新后，我们会在 发出更新版本，并在更新后的条款生效前通过官方网站公告或其他适当的方式提醒你更新的内容，以便你及时了解本隐私政策的最新版本，如你继续使用我们的服务，表示同意接受修订后的本政策的内容，但是如果更新的内容需要采集音视频、获取你通讯录、联系方式、地理位置等个人敏感信息，仍会再次以显著方式征求你的同意。',
        '（三）对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信、私信或在浏览页面做特别提示等方式，说明《隐私政策》的具体变更内容）。',
        '本《隐私政策》所指的重大变更包括但不限于：',
        '（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式等；',
        '（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有变更等；',
        '（3）个人信息共享、转让或公开披露的主要对象发生变化；        ',
        '（4）你参与个人信息处理方面的权利及其行使方式发生重大变化；',
        '（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。        ',
        '九、适用范围',
        '本隐私权政策不适用于：',
        '1. 其他第三方产品或服务，可能包括在个性化推荐中向你显示的产品或网站和广告内容或者 服务中链接到的其他产品或网站；',
        '2. 为 服务进行广告宣传的其他第三方',
        '你使用这些第三方服务（包括你向这些第三方提供的任何个人信息），将受这些第三方的服务条款及隐私政策约束（而非本隐私政策），具体规定请你仔细阅读第三方的条款。请你妥善保护自己的个人信息，仅在必要的情况下向第三方提供。',
        '请你了解，本隐私政策中所述的 及相关服务可能会根据你所使用的手机型号、系统版本、软件应用程序版本、移动客户端等因素而有所不同。最终的产品和服务以你所使用的 软件及相关服务为准。',
        '如对本隐私政策内容有任何疑问、意见或建议，你可通过登录 客户端内的“反馈意见”页面口与我们联系。',
        '十、其他',
        '（一）本“隐私政策”中的标题仅为方便及阅读而设，并不影响本《隐私政策》中任何规定的含义或解释。',
        '（二）本“隐私政策”相关词语释义：',
        '1. 及相关服务是指公司及其关联方通过合法拥有并运营的、标注名称为 的一些列客户端应用程序，向你提供的产品与服务，包括但不限于个性化推荐、发布信息、互动交流、搜索查询等核心功能以及其他功能，成为创作与交流的平台。',
        '2.关联方是指，指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的法定代表人。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被依法认定的方式。',
        '3.个人信息是指，以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括个人身份信息（姓名、出生日期、身份证件号码，包括身份证、军官证、护照、驾驶证）、面部特征、地址、联系电话、通信录、网络身份识别信息（包括账号名、账号昵称、邮箱地址以及与前述有关的密码与密码保护问题和答案）；财产信息、交易信息、个人上网记录（网络浏览记录、点击记录等）、个人常用设备信息（包括硬件型号、设备 MAC 地址、操作系统类型、软件列表唯一设备识别码等在内的描述个人常用终端设备基本情况的信息）、个人位置信息等。',
        '4.个人敏感信息是指，一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本隐私政策中的个人敏感信息包括：包括个人身份信息（身份证件号码，包括身份证、军官证、护照、驾驶证）、面部识别特征；财产信息、交易信息；网络身份识别信息（包括账号名、账号昵称、邮箱地址以及与前述有关的密码与密码保护问题和答案）；其他信息（包括通信录、个人电话号码、行程信息、精准定位信息）。',
        '5.去标识化是指，通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。',
        '6.匿名化是指，通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。',
        '本“隐私政策”的版权为我们所有，在法律允许的范围内，我们拥有解释和修改的权利。'

    ],
    'Agree and continue':"同意并继续",
    'canlce':"取消"
  }
  